import React, { useRef, useState, useEffect, useCallback, MutableRefObject } from 'react';
import Button from '../controls/forms/redesign/FormButton';

const FixedPanel: React.FunctionComponent<{}> = (props) => {
    return <div>{props.children}</div>;
};

FixedPanel.displayName = 'FixedPanel';

interface IHeaderProps {
    text: string;
    isFixed?: boolean;
}

const Header: React.FunctionComponent<IHeaderProps> = (props) => {
    return <h1>{props.text}</h1>;
};

Header.displayName = 'Header';

const useOnScreen = (ref: MutableRefObject<HTMLDivElement> | undefined) => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    useEffect(() => {
        let isOutsideViewport = true;
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            isOutsideViewport = (rect.bottom - window.innerHeight > -1);
        }
        const observer = new IntersectionObserver(([entry]) => {
            setIsIntersecting(entry.isIntersecting && isOutsideViewport);
        });
        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref && ref.current) {
                observer.unobserve(ref.current);
            }
        };
    });

    return isIntersecting;
};

interface ICardContainerProps {
    className?: string;
    style?: React.CSSProperties;
    showNextPagePanel?: boolean;
    nextPageAction?: () => void;
    getScrollStatus?: (divElement: HTMLDivElement) => void;
    buttonPaging?: boolean;
}

const CardContainer: React.FC<ICardContainerProps> = (props) => {
    const nextPagePanelRef = useRef();
    const onScreen = useOnScreen(nextPagePanelRef);

    useEffect(() => {
        if (onScreen) {
            props.nextPageAction();
        }
    }, [onScreen]);

    const handleScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
        if (props.getScrollStatus) {
            props.getScrollStatus(event.currentTarget);
        }
    }, [props.getScrollStatus]);

    return (
        <div onScroll={handleScroll} className={props.className} style={props.style}>
            <div className="dlc-card-container">{props.children}</div>
            {(props.showNextPagePanel && !props.buttonPaging) && (
                <div style={{ padding: '1rem' }} ref={nextPagePanelRef} />
            )}
            {props.buttonPaging && (
                <div className="bottom-button-row right-align">
                    <Button text="Load More..." onClick={props.nextPageAction} intent="primary" disabled={!props.showNextPagePanel} />
                </div>
            )}
        </div>
    );
};

CardContainer.displayName = 'CardContainer';
export default CardContainer;



// WEBPACK FOOTER //
// ./src/components/common/CardContainer.redesign.tsx